import { Box, useTheme } from '@mui/material';
import { Heading } from '../Heading/Heading';
import { Text } from '../Text/Text';
import { Button } from '../Button/Button';
import { buttonSx } from '../../styles/Global.style';
import {
  confirmationBtnSx,
  welcomeBtnContainerSx,
  welcomeContentSx,
  welcomeHeadingSx,
} from './Welcome.style';
import { MoodCheck } from '../MoodCheck/MoodCheck';
import { Form } from '../Form/Form';
import { useFormik } from 'formik';
import { WELCOME_INIT_VALUES } from '../../constants/welcome';
import { useAuth } from '../../hooks/useAuth/useAuth';
import { WELCOME_VALIDATION_SCHEMA } from '../../validation/welcome';
import { Copy } from '../../copy/Copy';
import { fetchAPI } from '../../utils/fetchAPI';
import { APIS } from '../../constants/apis';
import { useUser } from '../../hooks/useUser/useUser';

export const Welcome = () => {
  const theme = useTheme();
  const { user } = useAuth();
  const { mood } = useUser();

  const formik = useFormik({
    initialValues: WELCOME_INIT_VALUES,
    validationSchema: WELCOME_VALIDATION_SCHEMA,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (val) => {
      try {
        await fetchAPI({
          url: `${APIS.updateMood}${mood?.userId}`,
          method: 'PATCH',
          data: {
            initMood: val.mood ? parseInt(val.mood) : 0,
          },
          header: {
            Authorization: `Bearer ${user?.jwt}`,
          },
        });

        location.reload();
      } catch (err) {
        console.error(err.message);
      }
    },
  });

  return (
    <Box>
      <Heading
        level={1}
        text={Copy.generate('Welcome.heading')}
        color={theme.palette.tertiary.main}
        sx={welcomeHeadingSx}
      />
      <Text
        text={Copy.generate('Welcome.content')}
        color={theme.palette.secondary.main}
        sx={welcomeContentSx}
      />

      <Form formik={formik}>
        <MoodCheck formik={formik} />

        <Box sx={welcomeBtnContainerSx}>
          <Button
            text={Copy.generate('Buttons.submit')}
            type="submit"
            sx={{ ...buttonSx(theme), ...confirmationBtnSx }}
          />
        </Box>
      </Form>
    </Box>
  );
};
